import { useState } from "react";
import { Link } from "react-router-dom";
import { CaretLeft, MagnifyingGlass } from "@phosphor-icons/react";
import { SectionCards } from "../components/SectionCards";
import WebPage from "./WebPage";

const SECTIONS = [
  { id: "seo", title: "Monitoraggio SEO", icon: MagnifyingGlass, color: "#E9A23B", desc: "Stato, posizionamento e salute SEO dei siti dell'ecosistema", testId: "monitorsiti-section-seo" },
];

export default function MonitorSitiPage() {
  const [section, setSection] = useState(null);

  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="monitor-siti-page">
      <div className="mb-8 animate-fade-up">
        <Link to="/monitor" data-testid="monitor-siti-back" className="inline-flex items-center gap-1 text-xs text-white/50 hover:text-white transition-colors mb-3">
          <CaretLeft size={12} /> Monitor
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2">Monitor</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none">SITI</h1>
        <p className="text-sm text-slate-400 mt-3">Clicca la card per aprire la sezione corrispondente.</p>
      </div>

      <SectionCards sections={SECTIONS} active={section}
        onSelect={(s) => setSection(section === s.id ? null : s.id)} />

      {section === "seo" && <WebPage />}
    </main>
  );
}
